import axios from 'axios';

let prefix = "/equipment-set"

const EquipmentSetApi = {
	listEquipmentSets(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getEquipmentSet(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	getEquipmentSetRef(payload) {
		return axios.get(prefix + "/ref", { params: payload })
	},
	createEquipmentSet(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateEquipmentSet(payload) {
		return axios.post(prefix + "/update", payload)
	},
	archiveEquipmentSet(payload) {
		return axios.delete(prefix + "/archive", { data: payload })
	},
}

export default EquipmentSetApi;
